import React from 'react';
import PropTypes from 'prop-types';

const LikeInstructions = ({ className }) => (
  <svg
    width="43px"
    height="100px"
    viewBox="0 0 43 100"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="02_how-it-works-over-version_02"
        transform="translate(-257.000000, -280.000000)"
        fill="#FFFFFF"
      >
        <g id="Group-7" transform="translate(257.000000, 280.000000)">
          <g id="love">
            <path
              d="M42.3970294,27.478021 C42.4,26.2589635 41.4315804,25.2703745 40.2344237,25.2703745 C40.0650988,25.2703745 39.9017152,25.2855369 39.750214,25.3279916 C37.5311667,25.8435135 35.5467978,26.986759 33.9931676,28.5697144 C31.845415,30.7621985 30.5175514,33.7916476 30.5175514,37.1364747 L30.520522,40.1719888 L10.5342434,19.769453 C8.22310712,17.4101823 4.44151784,17.4101823 2.13335219,19.769453 C-0.177784065,22.1287236 -0.177784065,25.9890726 2.13335219,28.3453108 L11.3749266,37.7793608 C9.66682463,37.6004444 7.89931039,38.1553885 6.58927043,39.4896804 C5.68026311,40.4176198 5.1396117,41.5790602 4.94652191,42.7829554 L1.13522651,57.3631266 C0.612398769,59.3797268 1.11740284,61.6146657 2.66212116,63.1945886 L9.57176504,70.2481406 C17.0844432,77.9172865 29.2580118,77.9172865 36.77069,70.2481406 C40.4096899,66.5333508 42.2692931,61.7026077 42.3792057,56.8385073 L42.4,56.8567022 L42.4,56.3806026 C42.4,56.3715051 42.4,56.3624077 42.4,56.3593752 L42.3970294,27.478021 Z M39.4056229,56.7657277 C39.3046221,61.0597216 37.620285,65.0868571 34.6645259,68.1011437 C28.322269,74.5754918 18.0083036,74.5754918 11.6690172,68.1011437 L4.75937334,61.0475917 C4.01969091,60.2925038 3.74342398,59.2068754 4.0167203,58.1424743 L7.87257488,43.2772499 C7.94386958,42.8345075 8.14290059,42.188589 8.683552,41.6336449 C9.52423524,40.7754526 10.537214,40.7390628 11.0689536,40.7936475 L15.2188988,41.2212274 C15.8427273,41.2849095 16.4398203,40.9422391 16.7101461,40.3630351 C16.9804718,39.7838311 16.8616473,39.0954578 16.4190261,38.6405856 L4.23060438,26.1983138 C3.07206564,25.015646 3.07206564,23.0900203 4.23060438,21.9103849 C5.38914312,20.7277171 7.27548184,20.7277171 8.43104997,21.9103849 L29.4303073,43.3469969 C30.3244616,44.2597739 31.6345015,44.4508202 32.7217456,43.9534932 C33.1881317,43.738187 33.4881635,43.2651199 33.4881635,42.7435331 L33.4881635,37.1395072 C33.4881635,34.713522 34.4149945,32.4330959 36.0933904,30.7167113 C37.0410157,29.7493497 38.1757895,29.0185217 39.4234466,28.5666819 L39.4056229,56.7657277 Z"
              id="Shape"
              fillRule="nonzero"
              transform="translate(21.400000, 47.000000) scale(-1, 1) translate(-21.400000, -47.000000) "
            />
            <polygon
              id="Path"
              fillRule="nonzero"
              transform="translate(20.900000, 9.500000) rotate(-180.000000) translate(-20.900000, -9.500000) "
              points="31.4 7.92953076 16.142 7.92953076 21.572 2.22732548 19.451 0 10.4 9.50472558 19.439 19 21.56 16.7726745 16.142 11.0799204 31.4 11.0799204"
            />
            <path
              d="M20.1277253,64.3994415 C20.9170543,63.8704913 22.0469569,63.0357066 23.2342919,62.0155376 C25.5970067,59.9854717 27.1893542,58.0402479 27.5423234,56.4116394 C27.6801746,55.9621199 27.75,55.4979282 27.75,55.0313776 C27.75,53.3825107 26.9003388,51.8605825 25.5395637,51.0601022 C24.9118098,50.6935921 24.2009267,50.5 23.4844681,50.5 C22.3570526,50.5 21.2867766,50.9678668 20.4895641,51.80823 L20.1277588,52.1896188 L19.764968,51.8091673 C18.9630526,50.9682145 17.8899452,50.5 16.7627564,50.5 C16.0508557,50.5 15.3408387,50.6936155 14.7105472,51.0600085 C13.3495452,51.8576839 12.5,53.3795522 12.5,55.0313776 C12.5,55.4994719 12.5696069,55.9636575 12.7177355,56.4529217 C13.0366888,57.9349073 14.4540149,59.7392349 16.5927554,61.643951 C17.3666371,62.3331533 18.1847447,62.9904456 18.999053,63.5955104 C19.4732185,63.947835 19.8641309,64.2224263 20.1277253,64.3994415 Z"
              id="like"
              stroke="#FFFFFF"
            />
          </g>
          <text
            id="Like"
            fontFamily="GothamBold, Gotham"
            fontSize="14"
            fontWeight="bold"
          >
            <tspan x="7" y="99">
              Like
            </tspan>
          </text>
        </g>
      </g>
    </g>
  </svg>
);

LikeInstructions.propTypes = {
  className: PropTypes.string
};

LikeInstructions.defaultProps = {
  className: null
};

export default LikeInstructions;
